import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const searchTeams = unaryRpc({
  name: "searchTeams",
  input: z.object({
    query: z.string(),
    limit: z.number().optional().default(20),
    pageContinue: z.string().optional(),
    opensearchSearchAfter: z
      .array(z.union([z.string(), z.number()]))
      .optional(),
  }),
  output: z.object({
    teams: z.array(
      z.object({
        _id: zExt.objectId(),
        name: z.string(),
        email: z.string().optional(),
        logoUrl: z.string().optional(),
        storeUrl: z.string().optional(),
        publicDomain: z.string().optional(), // _shopify.domain - merchant's custom domain
        accountId: z.string().nullable().optional(),
      }),
    ),
    pageNext: z.string().optional(),
    nextSearchAfter: z.array(z.union([z.string(), z.number()])).optional(),
  }),
});
